import { render, staticRenderFns } from "./CollapsableMenuLinksMod.vue?vue&type=template&id=454980fe"
import script from "./CollapsableMenuLinksMod.vue?vue&type=script&lang=js"
export * from "./CollapsableMenuLinksMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports